import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { CommonService } from '@shared/common.service';
import { LangService } from '@services/lang.service';
import CONFIG from '@config/app.config';
import URL_CONFIG from '@config/url.config';
import { Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

import { ParticipantFaceoffsData, PlayerFaceoffsData } from '@interfaces/faceoffs.interface';

@Injectable({
    providedIn: 'root',
})
export class FaceoffsService {
    public constructor(
        private http: HttpClient,
        private common: CommonService,
        private lang: LangService,
    ) {
    }

    /**
     * Get Drafts
     * @return [description]
     */
    public getFaceoffs(
        tournamentId: any,
        participantId: any,
        seasonId?: any,
        subtournamentId?: any,
    ): Observable<ParticipantFaceoffsData> {
        let iso = this.lang.getLangSnapshot();

        if (iso == null) {
            iso = CONFIG.defaultLang;
        }

        const url = URL_CONFIG.api.getFaceoffs;

        const params = new HttpParams()
            .set('lang', iso)
            .set('tournamentId', tournamentId ?? '')
            .set('seasonId', seasonId ?? '')
            .set('subtournamentId', subtournamentId ?? '')
            .set('participantId', participantId ?? '');
        const options = params ? { params } : {};
        return this.http.get<ParticipantFaceoffsData>(url, options).pipe(
            catchError(this.common.errorCallback2()), // then handle the error
            tap(this.common.networkOnline()),
        );
    }

    /**
     * Get Drafts
     * @return [description]
     */
    public getPlayerFaceoffs(
        playerId: any,
        seasonId?: any,
        subtournamentId?: any,
    ): Observable<PlayerFaceoffsData> {
        let iso = this.lang.getLangSnapshot();

        if (iso == null) {
            iso = CONFIG.defaultLang;
        }

        const url = URL_CONFIG.api.getPlayerFaceoffs;

        const params = new HttpParams()
            .set('lang', iso)
            .set('seasonId', seasonId ?? '')
            .set('subtournamentId', subtournamentId ?? '')
            .set('playerId', playerId ?? '');
        const options = params ? { params } : {};
        return this.http.get<PlayerFaceoffsData>(url, options).pipe(
            catchError(this.common.errorCallback2()), // then handle the error
            tap(this.common.networkOnline()),
        );
    }
}
